import { handleSubmit } from "../form";

const handleDenial = crm => info => {
	handleSubmit({ crm, review: { denied: true }, ...info });
};

export default handleDenial;
